import { normalizeHostname } from '~~/layers/base/utils/normalizeHostname'

/**
 * Path helpers for the Crane Manager staff surface (TK-13632).
 *
 * `/crane-manager` and `/api/crane-manager` answer only on the env designer host
 * (or `NUXT_PUBLIC_CRANE_MANAGER_HOSTNAME` override) — see SPEC_crane_manager_host.
 */

export function isCraneManagerPath(pathname: string): boolean {
    return (
        pathname === '/crane-manager' ||
        pathname.startsWith('/crane-manager/') ||
        pathname === '/api/crane-manager' ||
        pathname.startsWith('/api/crane-manager/')
    )
}

/**
 * True when the request `Host` matches the configured staff hostname. Both sides
 * go through `normalizeHostname`, so a scheme-prefixed env value or a `:443`
 * suffix on the request still compare equal.
 *
 * Fail closed when the configured hostname is empty (callers should already 404
 * via `isCraneManagerSurfaceReady` before relying on this helper).
 */
export function isCraneManagerHostAllowed(
    requestHost: string,
    configuredHostname: string | undefined | null
): boolean {
    const expected = normalizeHostname(configuredHostname)
    if (!expected) {
        return false
    }
    return normalizeHostname(requestHost) === expected
}
